import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { CMTR_LGN, ENG, KND, MY_ACC, SRA, WLCM_KSRTC, t } from "../../translations/HeaderNew";
import { EN, KN } from "../../common/constants";
import { setLang } from "../../common/common";
// import { PhoneIcon, SideArrow } from "../common/icons/svg";
// import equal from "fast-deep-equal";
// import { getDateFormatted4 } from "../../common/common";
// import moment from "moment";
// import { renderImg } from "../common/icons/img";
// import { getImgPath } from "../common/helper";
let _lang = window.lang;
class HeaderNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // headertext1: [],
      // headertext2: [],
      ftSz: window.localStorage.getItem("ksrtcFtsz") ? window.localStorage.getItem("ksrtcFtsz") : 'original'
    };
    // this.updatedata = this.updatedata.bind(this);
  }

  // componentDidMount() {
  //   this.updatedata();
  // }

  // componentDidUpdate(prevProps) {
  //   if (!equal(this.props.search.header, prevProps.search.header)) {
  //     this.updatedata();
  //   }
  // }

  // updatedata() {
  //   if (Object.keys(this.props.search.header).length > 0) {
  //     this.setState({
  //       headertext1: this.props.search.header.text1,
  //       headertext2: this.props.search.header.text2,
  //     });
  //   }
  // }

  gotoLogin = () => {
    let url = window.location.pathname + window.location.search;
    window.sessionStorage.setItem("afterLoginRedirectUrl", url)
    window.open("/login", "_blank");
  }

  render() {
    // let headertext1 = [];
    // let headertext2 = [];
    const prop = this.props.search;
    const order = prop.order;
    //const Bookingnumber = window.Bookingcontact ? window.Bookingcontact : false;
    const welcomeMsg = window.welcomeMsg ? window.welcomeMsg : false;
    const contactNo = window.contactNo ? window.contactNo : false;
    // const othernumber = window.otherContact ? window.otherContact : false;
    // let trip = prop.searchParams.mode;
    // const urlParams = new URLSearchParams(window.location.search);
    // const inSrp =
    //   window.location.pathname && window.location.pathname.indexOf("/search");
    // const linkfromstoptocity = urlParams.get("linkfromstoptocity");
    // if (prop.searchParams.mode === "roundtrip") {
    //   trip = "Return trip";
    //   if (!prop.searchParams.token) {
    //     trip = "Onward trip";
    //   }
    // } else {
    //   trip = "Onward trip";
    // }
    // let fromcity = "",
    //   tocity = "";
    // if (prop) {
    //   fromcity = prop.searchParams.fromCity
    //     ? prop.searchParams.fromCity.split("|")[1]
    //     : "";
    //   tocity = prop.searchParams.toCity
    //     ? prop.searchParams.toCity.split("|")[1]
    //     : "";
    // }
    // if (Object.keys(order).length > 0) {
    //   if (trip === "Onward trip") {
    //     fromcity = order.onward.fromCity;
    //     tocity = order.onward.toCity;
    //   }
    //   if (trip === "Return trip") {
    //     if (order.return && order.return.seats) {
    //       fromcity = order.return.fromCity;
    //       tocity = order.return.toCity;
    //     }
    //   }
    // }
    // if (this.state.headertext1.length > 0) {
    //   headertext1 = this.state.headertext1;
    // } else {
    //   headertext1 = fromcity + " - " + tocity;
    // }
    // if (this.state.headertext2.length > 0) {
    //   headertext2 = this.state.headertext2;
    // } else {
    //   headertext1 = trip;
    // }

    // const onwardData = order && order.onward;
    // const returnData = order && order.return;
    return (
      <div className="header--section">
        <div className="header-screen-reader">
          <div className="header-screen-reader-left">
            {welcomeMsg} |&nbsp;<span>&#9742;</span>&nbsp;{contactNo}
          </div>
          <div className="header-screen-reader-right">
            <div className="block1">{t(SRA)}</div>
            <div className="block2">
              <div id="large" className={this.state.ftSz == 'large' ? 'active' : ''} onClick={() => setFontSize('large')}>A+</div>
              <div id="original" className={`brdlr ${this.state.ftSz == 'original' ? 'active' : ''}`} onClick={() => setFontSize('original')}>A</div>
              <div id="small" className={this.state.ftSz == 'small' ? 'active' : ''} onClick={() => setFontSize('small')}>A-</div>
            </div>
            <div className="block3">
              <div onClick={() => setThemeColor('SC')}>SC</div>
              <div className="line">|</div>
              <div onClick={() => setThemeColor('HC')}>HC</div>
            </div>
            <div className="block4">
              <div className="circle-orange" onClick={() => setThemeColor('orange')}></div>
              <div className="circle-blue" onClick={() => setThemeColor('blue')}></div>
              <div className="circle-green" onClick={() => setThemeColor('green')}></div>
              <div className="circle-black" onClick={() => setThemeColor('brown')}></div>
            </div>
            {/* <div className="block5">
              <div className={`left ${_lang == EN ? "active" : ""}`} onClick={() => { setLang(EN) }}>{t(ENG)}</div>
              <div className="center">|</div>
              <div className={`right ${_lang == KN ? "active" : ""}`} onClick={() => { setLang(KN) }}>{t(KND)}</div>
            </div> */}
          </div>
        </div>
        <div className="header-top-wrapper">
          <div className="header-logo">
            <a href="/">
              <img
                src={window.awsImagePath + window.Searchlogo}
                alt={window.companyName}
                width="368"
                height="68"
              />
            </a>
          </div>
          <div className="header-right" style={{ justifyContent: 'end' }}>
            <div className="header-right-item">
              {
                window.customerProfile?.isLoggedIn ?
                  <a
                    className="link-btn"
                    href="/account?profile=true"
                    target="_blank"
                    style={{ padding: '10px 20px', borderRadius: '50px' }}
                  >
                    {t(MY_ACC)}
                  </a>
                  :
                  <a
                    className="link-btn"
                    href="#"
                    onClick={this.gotoLogin}
                    target="_blank"
                    style={{ padding: '10px 20px', borderRadius: '50px' }}
                  >
                    {t(CMTR_LGN)}
                  </a>
              }
            </div>
            {/* <div className="header-right-item">
              <a
                className="link"
                href="http://kasrtcweb.mavenconnect.biz/"
                target="_blank"
              >
                <img src={getImgPath("/img/opfr.svg")} />
                <span className="header-right-item-text">
                  Operator / Franchisee
                </span>
              </a>
            </div>
            <div className="header-right-item">
              <a
                className="link"
                href="http://mitra.ksrtc.in/MysoreMBus/"
                target="_blank"
              >
                <img src={getImgPath("/img/mitra.svg")} />
                <span className="header-right-item-text">Mitra</span>
              </a>
            </div>
            <div className="header-right-item">
              <a
                className="link"
                href="https://ksrtchelp.freshdesk.com/"
                target="_blank"
              >
                <img src={getImgPath("/img/crm.svg")} />
                <span className="header-right-item-text">CRM</span>
              </a>
            </div>
            <div className="header-right-item">
              <a
                className="link"
                href="https://login.microsoftonline.com"
                target="_blank"
              >
                <img src={getImgPath("/img/ic-email.svg")} />
                <span className="header-right-item-text">KSRTC Email</span>
              </a>
            </div>
            <div className="header-right-item">
              <a
                className="link"
                href="http://vtms.ksrtc.in/KSRTC-VTMS_new/"
                target="_blank"
              >
                <img src={getImgPath("/img/trackbus.svg")} />
                <span className="header-right-item-text">Track Your Bus</span>
              </a>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = function (store) {
  return store;
};
export default connect(mapStateToProps)(withRouter(HeaderNew));
